import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form__field" }
const _hoisted_2 = ["name", "id", "value"]
const _hoisted_3 = ["for"]

import {useI18n} from "vue3-i18n";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'FormReadonlyField',
  props: {
    name: {},
    label: {},
    modelValue: {}
  },
  setup(__props: any) {



const {t} = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "text",
      readonly: "",
      name: _ctx.name,
      id: _ctx.name,
      value: _ctx.modelValue ? _ctx.modelValue : _unref(t)('global.undefined')
    }, null, 8, _hoisted_2),
    _createElementVNode("label", { for: _ctx.name }, _toDisplayString(_ctx.label ? _ctx.label : _ctx.name), 9, _hoisted_3)
  ]))
}
}

})